import { Card } from '@/components/ui';
import { LatencyLeadChart } from '@/components/charts';
import { BenchmarkDetail } from '@/components/benchmark';
import { Callout } from '@/components/investor';
import { CUDA, MLX } from '@/content/benchmarks';

export function CudaBenchmarkPage() {
  return (
    <BenchmarkDetail
      platform={CUDA}
      other={MLX}
      e2eExtra={
        <>
          <Card variant="raised" className="p-5 sm:p-8">
            <p className="label mb-4">Latency lead across the response-time distribution</p>
            <LatencyLeadChart />
          </Card>
          <Callout title="What that means for a competitor">
            A reactive application layer is not where the gain is. It appears only when admission, capacity signalling and cancellation continue
            <em> through</em> the inference boundary — which means owning both sides of it. That is what Fnk built, and why the framework and the engine
            are sold as one product.
          </Callout>
        </>
      }
    />
  );
}
